import classNames from 'classnames';
import ReactCollapsible from 'react-collapsible';

import { PropsWithClassname } from '@/app/types';

import ChevronIcon from '@/app/components/ChevronIcon/ChevronIcon';

interface Collapsible extends PropsWithClassname {
  heading: string;
  text: string;
  defaultOpen?: boolean;
}

const Collapsible = ({ heading, text, defaultOpen, className }: Collapsible) => {
  return (
    <ReactCollapsible
      trigger={
        <div className="flex justify-between items-center font-medium pb-[40px]">
          <span>{heading}</span>
          <ChevronIcon className={classNames('text-neutral-midLight transition-transform w-[20px] h-[20px]')} />
        </div>
      }
      containerElementProps={{
        className: classNames(
          className,
          'bg-white w-full mb-[16px] rounded-md border border-neutral-light px-[40px] pt-[40px]',
        ),
      }}
      triggerClassName="[&>div>svg]:rotate-0"
      triggerOpenedClassName="[&>div>svg]:rotate-180"
      transitionTime={300}
      easing="ease"
      open={defaultOpen}
    >
      <div className="pb-[40px]">{text}</div>
    </ReactCollapsible>
  );
};

export default Collapsible;
